export default {
  methods: {
    validIssueWeight() {
      return false;
    },
  },
};
